import React, { useMemo, useState, useEffect } from "react"
import he from "he";
import "./SourcingMethodology.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";

const LeftImageSection = () => {

  const [sourcingMethodology, setSourcingMethodology] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.sourcing_methodology) {
        setSourcingMethodology(he.decode(page.data.sourcing_methodology.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(sourcingMethodology), [sourcingMethodology]);
  
    return (
      <div>
        {processedContent && (
          <div className="sourcingMethodology" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };

export default LeftImageSection;
